import { useState, useEffect } from "react";
import "./UploadDraftComponent.scss";
const UploadDraftComponent = ({
  roleInfo,
  onDraftDelete,
  onDraftSubmit,
  uploaded,
  isCardClick,
  setIsCardClick,
  type,
  setSubmitId,
  userDetails,
  setShowVideo,
}) => {
  const deleteClicked = () => {
    onDraftDelete(roleInfo?.roleplay_id);
  };
  const submitClicked = () => {
    onDraftSubmit(roleInfo?.roleplay_id);
  };

  console.log("roleinfo--", roleInfo);

  return (
    <>
      <div className="uploade-draft">
        <div className="draft-roleplay">
          <div className="draft-img-box cursor-pointer">
            <img
              src={roleInfo?.thumbnail}
              className="drft-img"
              alt=""
              onClick={() => {
                setIsCardClick(type);
                setShowVideo(false);
                setSubmitId(roleInfo?.roleplay_id);
              }}
            />
          </div>
          <div className="draft-info">
            <ul className="cardlist-row">
              <li>
                <span>{roleInfo?.type === "video" ? "Video" : "Audio"}</span>
              </li>
              <li>
                <span>{roleInfo?.formattedDate}</span>
              </li>
              {/* <li>
                <span>{roleInfo?.formattedDate?.time}</span>
              </li> */}
              <li>
                <span>{roleInfo?.formattedDuration}</span>
              </li>
            </ul>
            {uploaded && (
              <ul className="cardlist-row">
                <li>
                  <span>
                    Submitted to {roleInfo?.coach_name} on{" "}
                    {roleInfo?.formattedDate}
                  </span>
                </li>
              </ul>
            )}
            {roleInfo?.feedbackData?.review_status ? (
              <ul className="cardlist-row">
                <li>
                  <span style={{ color: "green" }}>
                    Reviewed by {roleInfo?.coach_name} on{" "}
                    {roleInfo?.formatReviewedDate}
                  </span>
                </li>
              </ul>
            ) : (
              uploaded && (
                <ul className="cardlist-row">
                  <li>
                    <span style={{ color: "red" }}>Under review</span>
                  </li>
                </ul>
              )
            )}
          </div>
          {!uploaded && (
            <div className="draft-footer">
              <button className="delete-btn" onClick={() => deleteClicked()}>
                Delete draft{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    opacity="0.4"
                    d="M13.3337 5.00008V4.33341C13.3337 3.39999 13.3337 2.93328 13.152 2.57676C12.9922 2.26316 12.7372 2.00819 12.4236 1.8484C12.0671 1.66675 11.6004 1.66675 10.667 1.66675H9.33366C8.40024 1.66675 7.93353 1.66675 7.57701 1.8484C7.2634 2.00819 7.00844 2.26316 6.84865 2.57676C6.66699 2.93328 6.66699 3.39999 6.66699 4.33341V5.00008"
                    stroke="black"
                    strokeWidth="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.5 5H17.5M15.8333 5V14.3333C15.8333 15.7335 15.8333 16.4335 15.5608 16.9683C15.3212 17.4387 14.9387 17.8212 14.4683 18.0609C13.9335 18.3333 13.2335 18.3333 11.8333 18.3333H8.16667C6.76654 18.3333 6.06647 18.3333 5.53169 18.0609C5.06129 17.8212 4.67883 17.4387 4.43915 16.9683C4.16667 16.4335 4.16667 15.7335 4.16667 14.3333V5"
                    stroke="#B42318"
                    strokeWidth="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
              <button
                className="upload-review-btn"
                onClick={() => submitClicked()}
                disabled={!userDetails.coach_id}
                title={
                  !userDetails.coach_id
                    ? "You need a coach to submit roleplay for review"
                    : ""
                }
              >
                Upload for review{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M1.66699 2.50008C1.66699 2.03984 2.04009 1.66675 2.50033 1.66675H17.5003C17.9606 1.66675 18.3337 2.03984 18.3337 2.50008C18.3337 2.96032 17.9606 3.33341 17.5003 3.33341H2.50033C2.04009 3.33341 1.66699 2.96032 1.66699 2.50008Z"
                    fill="#415385"
                  />
                  <path
                    d="M4.41107 11.4227C4.73651 11.7481 5.26414 11.7481 5.58958 11.4227L9.16699 7.84526L9.16699 17.5001C9.16699 17.9603 9.54009 18.3334 10.0003 18.3334C10.4606 18.3334 10.8337 17.9603 10.8337 17.5001L10.8337 7.84526L14.4111 11.4227C14.7365 11.7481 15.2641 11.7481 15.5896 11.4227C15.915 11.0972 15.915 10.5696 15.5896 10.2442L10.5896 5.24416C10.2641 4.91872 9.73651 4.91872 9.41107 5.24416L4.41107 10.2442C4.08563 10.5696 4.08563 11.0972 4.41107 11.4227Z"
                    fill="#415385"
                  />
                </svg>
              </button>
            </div>
          )}
        </div>
        {/* <div className="draft-roleplay">
              <div className="without-img-draft">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path d="M43.9998 35.0001L35.9998 27.0001V30.3501L31.9998 26.3501V12.0001H17.6498L13.6498 8.0001H31.9998C33.0998 8.0001 34.0415 8.39176 34.8248 9.1751C35.6081 9.95843 35.9998 10.9001 35.9998 12.0001V21.0001L43.9998 13.0001V35.0001ZM41.0998 46.7001L1.2998 6.9001L4.0998 4.1001L43.8998 43.9001L41.0998 46.7001ZM7.9998 8.0001L11.9998 12.0001H7.9998V36.0001H31.9998V32.0001L35.9998 36.0001C35.9998 37.1001 35.6081 38.0418 34.8248 38.8251C34.0415 39.6084 33.0998 40.0001 31.9998 40.0001H7.9998C6.8998 40.0001 5.95814 39.6084 5.1748 38.8251C4.39147 38.0418 3.9998 37.1001 3.9998 36.0001V12.0001C3.9998 10.9001 4.39147 9.95843 5.1748 9.1751C5.95814 8.39176 6.8998 8.0001 7.9998 8.0001Z" fill="#E1D8F5"/>
                </svg>
              </div>
              <div className="draft-info">
                <ul className="cardlist-row">
                  <li>
                    <span>Xsel</span>
                  </li>
                  <li>
                    <span>Course</span>
                  </li>
                  <li>
                    <span>6 Modules</span>
                  </li>
                  <li>
                    <span>01 Hour 02 Mins </span>
                  </li>
                </ul>
              </div>
              <div className="draft-footer">
                <button className="delete-btn">
                  Delete draft{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      opacity="0.4"
                      d="M13.3337 5.00008V4.33341C13.3337 3.39999 13.3337 2.93328 13.152 2.57676C12.9922 2.26316 12.7372 2.00819 12.4236 1.8484C12.0671 1.66675 11.6004 1.66675 10.667 1.66675H9.33366C8.40024 1.66675 7.93353 1.66675 7.57701 1.8484C7.2634 2.00819 7.00844 2.26316 6.84865 2.57676C6.66699 2.93328 6.66699 3.39999 6.66699 4.33341V5.00008"
                      stroke="black"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.5 5H17.5M15.8333 5V14.3333C15.8333 15.7335 15.8333 16.4335 15.5608 16.9683C15.3212 17.4387 14.9387 17.8212 14.4683 18.0609C13.9335 18.3333 13.2335 18.3333 11.8333 18.3333H8.16667C6.76654 18.3333 6.06647 18.3333 5.53169 18.0609C5.06129 17.8212 4.67883 17.4387 4.43915 16.9683C4.16667 16.4335 4.16667 15.7335 4.16667 14.3333V5"
                      stroke="#B42318"
                      strokeWidth="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
                <button className="upload-review-btn">
                Upload for review{" "}
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M1.66699 2.50008C1.66699 2.03984 2.04009 1.66675 2.50033 1.66675H17.5003C17.9606 1.66675 18.3337 2.03984 18.3337 2.50008C18.3337 2.96032 17.9606 3.33341 17.5003 3.33341H2.50033C2.04009 3.33341 1.66699 2.96032 1.66699 2.50008Z" fill="#415385"/>
                    <path d="M4.41107 11.4227C4.73651 11.7481 5.26414 11.7481 5.58958 11.4227L9.16699 7.84526L9.16699 17.5001C9.16699 17.9603 9.54009 18.3334 10.0003 18.3334C10.4606 18.3334 10.8337 17.9603 10.8337 17.5001L10.8337 7.84526L14.4111 11.4227C14.7365 11.7481 15.2641 11.7481 15.5896 11.4227C15.915 11.0972 15.915 10.5696 15.5896 10.2442L10.5896 5.24416C10.2641 4.91872 9.73651 4.91872 9.41107 5.24416L4.41107 10.2442C4.08563 10.5696 4.08563 11.0972 4.41107 11.4227Z" fill="#415385"/>
                    </svg>
                </button>
              </div>
            </div> */}
      </div>
    </>
  );
};

export default UploadDraftComponent;
